/**
 * Wartet am Ende DIESES Zugs eine Fragen-Runde auf Martin? (29.09.2026,
 * Ticket 2790)
 *
 * Martin, 29.09., 06:59, mitten in der Runde „offene Fragen“: *„Wir sind
 * mitten in einem Prozess und du kommunizierst nicht weiter.“* Vespera hatte
 * nach zwei neuen Tickets mit einer Feststellung geendet; die App sah keine
 * Frage am Schluss — in der Stufe „nach Frage“ ging das Mikro nicht auf.
 *
 * Ob die Runde wartet, weiß nur der Server (tools/tickets.ts, rundeWartet) —
 * er sagt es am Zugende mit dem Ereignis `runde`, und nur, wenn die Runde in
 * DIESEM Zug gefragt hat. Hier steht nur der Merker. Wie lange das Mikro
 * dann zuhört, bleibt die Einstellung „Kurz zuhören“ (Ticket 2668).
 *
 * ⚠️ EIN Besitzer: nur diese Datei schreibt ihn. Er gilt für DIESEN Zug —
 *    eroeffneZug (app.ts) setzt ihn zurück, der Hörer am Vorlese-Ende löst
 *    ihn einmal ein. Ein abgebrochenes Vorlesen meldet kein Ende; ohne den
 *    Rücksatz beim nächsten Zug hielte der alte Merker dessen Mikro offen.
 */

let wartet = false;

/** Ein neuer Zug beginnt ohne wartende Runde. */
export function zugOhneRunde(): void {
  wartet = false;
}

/** Das Zugende meldet: die Runde wartet auf seine Antwort. */
export function merkeRunde(w: boolean): void {
  wartet = w;
}

/** Nur ansehen, nichts löschen (Mikro-Vorstart, mikro-vorstart.ts): wartet die Runde auf ihn? */
export function rundeAnsehen(): boolean {
  return wartet;
}

/** Am Vorlese-Ende: wartet die Runde auf ihn? Einmal gelesen, dann gelöscht. */
export function rundeEinloesen(): boolean {
  const war = wartet;
  wartet = false;
  return war;
}
